export function isRunningUnitTest() {
    if (typeof process !== 'undefined') {
        return process.env.JEST_WORKER_ID !== undefined;
    }
    return false;
}
